const { lagoonSDK } = require('./lagoonSDK');
const { ppdLagoon } = require('./ppdLagoon');
const { paanLagoon } = require('./paanLagoon');

module.exports = { lagoonSDK, ppdLagoon, paanLagoon };
